export function isPromise (obj) {
  return !! obj && (typeof obj === 'object' || typeof obj === 'function') && typeof obj.then === 'function'
}
